import { EntityTypes } from 'constants/entities';
import { IBaseEntity } from './base';
import { IModule, IModuleBasicDAO } from './module';

export interface IText extends IBaseEntity {
  shortText: string;
  html: string;
  htmlJson: ITextHTMLBlockJSON[];
  type?: number;
  color?: TextColor;
}

export enum TextColor {
  BLACK = 0,
  WHITE = 1,
  BRAND = 2,
}



export interface ITextDAO extends IText {
  translations?: ITranslation[];
}

export interface ITextSearchDAO extends IBaseEntity {
  shortText: string;
  html: string;
  htmlJson: ITextHTMLBlockJSON[];
  actionId: number;
  moduleId: number;
  module: IModuleBasicDAO;
}

export interface ITranslation extends IBaseEntity {
  textId: number;
  languageId: number;
  shortText: string;
  html: string;
}

export interface ITemplate extends IBaseEntity {
  shortText: string;
  html: string;
}

// follow the format of slate
export interface ITextHTMLBlockJSON extends IBaseEntity {
  type: string;
  align: string;
  children: ITextHTMLChildrenJSON[];
}

export interface ITextHTMLChildrenJSON extends IBaseEntity {
  text: string;
  bold: boolean;
  italic: boolean;
  underline: boolean;
  url;
}
